









































import Vue, { PropType } from 'vue';
import Dropdown from '../Dropdown/Dropdown.vue';
import DropdownItem from '../DropdownItem/DropdownItem.vue';
import DropdownItems from '../DropdownItems/DropdownItems.vue';
import DropdownItemGroup from '../DropdownItemGroup/DropdownItemGroup.vue';
import Input from '../../../forms/Input/Input.vue';
import Button from '../../../buttons/Button/Button.vue';
import ButtonGroup from '../../../buttons/ButtonGroup/ButtonGroup.vue';
import CheckboxButton from '../../../buttons/CheckboxButton/CheckboxButton.vue';

const match = (target: any, searchText: string): boolean => {
  switch (typeof(target)) {
    case 'bigint':
    case 'number':
      return target.toString().includes(searchText);
    case 'string':
      return target.includes(searchText);
    case 'object':
      for (const key in target) {
        if (match(target[key], searchText)) { return true; }
      }
      return false;
    default:
      return false;
  }
};

export default Vue.extend({
  name: 'MultiSelectDropdown',
  components: {
    Dropdown,
    DropdownItem,
    DropdownItemGroup,
    DropdownItems,
    Button,
    ButtonGroup,
    CheckboxButton,
    Input,
  },
  props: {
    value: { // selected Items
      type: Array as PropType<any[]>,
      default: [],
    },
    options: {
      type: Array as PropType<any[]>,
      default: () => ([]),
    },
    fullWidth: {
      type: Boolean,
      default: true,
    },
    match: Function as PropType<(target: any, searchText: string)=>boolean>,
    optionLabelName: String,
  },
  data() {
    return {
      searchText: '',
      focusTarget: null as HTMLElement | null,
    };
  },
  computed: {
    myOptions(): string[] {
      return this.options.filter((cur)=> {
        if (this.match) {
          return this.match(cur, this.searchText);
        } else {
          return match(cur, this.searchText);
        }
      });
    },
  },
  methods: {
    selectAll() {
      this.$emit('input', this.options);
    },
    clear() {
      this.$emit('input', []);
    },
    toggleCheckbox(option: string) {
      if (this.value.includes(option)) {
        this.$emit('input', this.value.filter((cur)=> {
          return cur !== option;
        }));
      } else {
        return this.$emit('input', [...this.value, option]);
      }
    },
  },
  mounted() {
    this.focusTarget = (this.$refs.search as Vue).$el.querySelector('.component.base-input');
  },
});
